import { isFunction } from "./share";

abstract class TsStroage {
    //同步版本
    abstract setStorageSync(key: string, data: any, isSession?: boolean): void;
    abstract setStorageSync(key: string, data: any, isSession?: boolean): void;
    abstract removeStorageSync(key: string, isSession?: boolean): void;
    abstract clearStorageSync(isSession?: boolean): void;
    //异步版本
    abstract setStorage(object: any): void;
    abstract getStorage(object: any): void;
    abstract removeStorage(object: any): void;
    abstract clearStorage(object: any): void;
}

export default class Stroage implements TsStroage {
    private getDataType(data: any) {
        let result = "";

        let type = typeof data;

        if (
            type === "boolean" ||
            type === "string" ||
            type === "number" ||
            type === "undefined" ||
            type === "function" ||
            type === "symbol"
        ) {
            result = type;
        } else if (data === null) {
            result = "null";
        } else if (data instanceof Array) {
            result = "array";
        } else if (data instanceof Object) {
            result = "object";
        }

        return result;
    }

    setStorageSync(key: string, data: any, isSession?: boolean) {
        let _data: any = {};

        _data.type = this.getDataType(data);
        _data.data = data;

        window[isSession ? "sessionStorage" : "localStorage"].setItem(
            key,
            JSON.stringify(_data)
        );
    }

    getStorageSync(key: string, isSession?: boolean) {
        let _data: any = window[
            isSession ? "sessionStorage" : "localStorage"
        ].getItem(key);

        if(_data){
            try {
                _data = JSON.parse(_data); 
                return _data.data;
            } catch (error) {
                console.error('从localstore获取'+key+"报错",_data,error);
            }
        }
        return undefined;

        // if (_data && typeof _data == 'object') {
        //     return JSON.parse(_data).data;
        // } else if (typeof _data == 'string') {
        //     return _data;
        // }
        // return undefined;
    }

    removeStorageSync(key: string, isSession?: boolean) {
        window[isSession ? "sessionStorage" : "localStorage"].removeItem(key);

    }

    clearStorageSync(isSession?: boolean) {
        window[isSession ? "sessionStorage" : "localStorage"].clear();
    }

    setStorage(object: any) {
        let _this = this;

        if (object.key && this.getDataType(object.key) === "string") {
            setTimeout(function () {
                try {
                    _this.setStorageSync(
                        object.key,
                        object.data,
                        object.isSession
                    );
                    isFunction(object.success) && object.success();
                } catch (e) {
                    isFunction(object.error) && object.error();
                } finally {
                    isFunction(object.complete) && object.complete();
                }
            }, 0);
        }
    }

    getStorage(object: any) {
        let _this = this;

        if (object.key && this.getDataType(object.key) === "string") {
            setTimeout(function () {
                try {
                    isFunction(object.success) &&
                        object.success(
                            _this.getStorageSync(object.key, object.isSession)
                        );
                } catch (e) {
                    isFunction(object.error) && object.error();
                } finally {
                    isFunction(object.complete) && object.complete();
                }
            }, 0);
        }
    }

    removeStorage(object: any) {
        let _this = this;

        if (object.key && this.getDataType(object.key) === "string") {
            setTimeout(function () {
                try {
                    _this.removeStorageSync(object.key, object.isSession);
                    isFunction(object.success) && object.success();
                } catch (e) {
                    isFunction(object.error) && object.error();
                } finally {
                    isFunction(object.complete) && object.complete();
                }
            }, 0);
        }
    }

    clearStorage(object: any) {
        let _this = this;

        setTimeout(function () {
            try {
                _this.clearStorageSync(object.isSession);
                isFunction(object.success) && object.success();
            } catch (e) {
                isFunction(object.error) && object.error();
            } finally {
                isFunction(object.complete) && object.complete();
            }
        }, 0);
    }
}



// WEBPACK FOOTER //
// ./src/common/ts/stroage.ts